import React from 'react';

const IconLogo = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
    <title>Logo</title>
    <g transform="translate(-8.000000, -2.000000)">
      <g transform="translate(11.000000, 5.000000)">
        <path
          d="M33.5977 49.9707V65H24.8086V22.3438H41.4492C44.6523 22.3438 47.4648 22.9297 49.8867 24.1016C52.3281 25.2734 54.2031 26.9434 55.5117 29.1113C56.8203 31.2598 57.4746 33.7109 57.4746 36.4648C57.4746 40.6445 56.0391 43.9453 53.168 46.3672C50.3164 48.7695 46.3613 49.9707 41.3027 49.9707H33.5977ZM33.5977 42.8516H41.4492C43.7734 42.8516 45.541 42.3047 46.752 41.2109C47.9824 40.1172 48.5977 38.5547 48.5977 36.5234C48.5977 34.4336 47.9824 32.7441 46.752 31.4551C45.5215 30.166 43.8223 29.502 41.6543 29.4629H33.5977V42.8516Z"
          fill="currentColor"
        />
        <polygon
          id="Shape"
          stroke="currentColor"
          strokeWidth="5"
          strokeLinecap="round"
          strokeLinejoin="round"
          points="39 0 0 22 0 67 39 90 78 68 78 23"
        />
      </g>
    </g>
  </svg>
);

export default IconLogo;
